export const setToken = (token) => {
  localStorage.setItem('dealboxx_token', token);
};

export const getToken = () => {
  return localStorage.getItem('dealboxx_token');
};

export const removeToken = () => {
  localStorage.removeItem('dealboxx_token');
};
